export enum PositionAssistantTaskEnum {
  ActivateAutomatedOutreach = 'ACTIVATE_AUTOMATED_OUTREACH',
  BuildStrongCandidatePipeline = 'BUILD_STRONG_CANDIDATE_PIPELINE',
  ImproveOutreachEngagement = 'IMPROVE_OUTREACH_ENGAGEMENT',
  ATSIntegration = 'ATS_INTEGRATION',
  PromptFollowup = 'PROMPT_FOLLOWUP',
  EncourageTimelyReplies = 'ENCOURAGE_TIMELY_REPLIES',
  OutreachToLikedMatches = 'OUTREACH_TO_LIKED_MATCHES',
}
